/**
 * @file
 * A JavaScript file for the theme.
 *
 * In order for this JavaScript to be loaded on pages, see the instructions in
 * the README.txt next to this file.
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth
(function ($, Drupal) {
    jQuery(document).ready(function($) {
        $('#superfish-main-accordion a').on('click', function() {
            $('#superfish-main-accordion').removeClass('sf-expanded');
            setTimeout(function() {
                $('#superfish-main-accordion').addClass('sf-hidden');
            }, 630);
        })
    });
})(jQuery, Drupal);



       
